<template>
  <div class="body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f3']"
          @shortkey="showHiden = !showHiden"
        ></button>
        <div class="mt-2">
          <el-row :gutter="10">
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-input
                  @change="selectSearchCode"
                  placeholder="بحث بالفاتورة "
                  autofocus
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8" :md="6" :sm="12">
              <div class="bg-White p-3">
                <SearchCustomers
                  :searchOnly="true"
                  :customer="customer"
                  @selectedCustomer="selectedCustomer"
                  :productsLength="productsLength"
                  :productSearch="false"
                  :showLabel="false"
                />
              </div>
            </el-col>
            <el-col :xl="7" :lg="7" :md="6" :sm="12">
              <div class="bg-White p-3">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  @change="selectDateRange"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                  style="width: 100%"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :lg="4" :md="6">
              <div class="bg-White p-3">
                <el-select v-model="type" @change="selectType">
                  <el-option value="3" label="كل الفواتير"></el-option>
                  <el-option value="1" label="فواتير فاتورة"></el-option>
                  <el-option value="2" label="فواتير المحل"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col
              :xl="2"
              :lg="2"
              :md="6"
              :sm="12"
              v-if="accessLinks('print_sale_bill')"
            >
              <div class="bg-White p-3">
                <el-button
                  type="success"
                  title="طباعه"
                  icon="el-icon-printer"
                  @click="sendToPrintAll(tableData)"
                ></el-button>
              </div>
            </el-col>
          </el-row>
          <customer-info
            :customer="customer"
            :type="'customer'"
            v-if="customer != null"
          />
        </div>
        <el-row :gutter="10" v-if="showHiden">
          <el-col :xl="24" :lg="24" :md="6" :sm="12">
            <el-button type="success">
              المبيعات بسعر الشراء |

              {{ numberToFixed(buyCost) }}</el-button
            >
            <el-button type="primary" class="mr-2">
              المبيعات بسعرالبيع |
              {{ numberToFixed(saleCost) }}</el-button
            >
            <el-button type="danger" class="mr-2">
              الخصومات|
              {{ numberToFixed(totalDiscount) }}</el-button
            >
            <el-button type="warning" class="mr-2 mt-2">
              الربح |
              {{ numberToFixed(saleCost - buyCost - totalDiscount) }}</el-button
            >
          </el-col>
        </el-row>
        <el-table
          class="mt-2"
          align="right"
          style="overflow: auto"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          :style="customer ? 'max-height: 74%;' : 'max-height: 80%;'"
        >
          <!-- style="width: 100%" -->
          <el-table-column label="#" type="index" width="50">
            <template slot-scope="scope">
              <div v-if="scope.row.fatura_id == null">
                {{ scope.$index + 1 }}
              </div>
              <div v-else>
                <!-- <img
                  src="../../images/logo.png"
                  width="24"
                  height="24"
                  alt="Fatura Logo"
                /> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable width="100" label="الفاتورة" prop="id">
          </el-table-column>

          <el-table-column label="القيمة" prop="total_cost"> </el-table-column>
          <el-table-column label="الخصم" prop="discount"> </el-table-column>
          <el-table-column label="مرتجع" prop="returned_amount">
          </el-table-column>
          <el-table-column label="الاجمالي" prop="total">
            <template slot-scope="scope">
              {{
                scope.row.total - scope.row.returned_amount - scope.row.discount
              }}
            </template>
          </el-table-column>
          <el-table-column label="الربح" prop="profit" v-if="showHiden">
            <template slot-scope="scope">
              {{ numberToFixed(scope.row.profit - scope.row.discount) }}
            </template>
          </el-table-column>
          <el-table-column width="160" label="العميل" prop="customer.name">
          </el-table-column>
          <el-table-column label="بواسطة" prop="user.name"> </el-table-column>
          <el-table-column
            width="170"
            sortable
            label="التوقيت"
            prop="created_at"
          >
            <template slot-scope="scope">
              {{ scope.row.created_at | moment("Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
          <el-table-column label="اجراءات" width="120">
            <template slot-scope="scope">
              <el-row :gutter="10">
                <el-col :lg="12" v-if="accessLinks('update_sales_bill')">
                  <router-link
                    title="تعديل الفاتورة"
                    :to="{ path: '/sales/edit/' + scope.row.id }"
                  >
                    <el-button
                      size="mini"
                      type="warning"
                      title="تعديل"
                      icon="el-icon-edit"
                    >
                    </el-button>
                  </router-link>
                  <!-- <el-button
                    size="mini"
                    type="warning"
                    title="تعديل الفاتورة"
                    icon="el-icon-edit"
                    @click="goTo(scope.row)"
                  ></el-button> -->
                </el-col>
                <el-col :lg="12" v-if="accessLinks('print_sale_bill')">
                  <el-button
                    type="success"
                    size="mini"
                    title="طباعه"
                    icon="el-icon-printer"
                    @click="sendToPrint(scope.row)"
                  ></el-button>
                </el-col>
                <!-- <el-col :lg="8">
                  <el-popconfirm
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    title="هل تريد حذف البيانات؟"
                    @confirm="deleteInvoice(scope)"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      size="mini"
                      title="مسح"
                      icon="el-icon-delete"
                    ></el-button>
                  </el-popconfirm>
                </el-col> -->
              </el-row>
            </template>
            <!-- <template slot-scope="scope">
              <el-button-group>
                <router-link
                  title="تعديل الفاتورة"
                  :to="{ path: '/sales/edit/' + scope.row.id }"
                >
                  <el-button type="warning" title="تعديل" icon="el-icon-edit">
                    تعديل
                  </el-button>
                </router-link>

              </el-button-group>
            </template> -->
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                class="mt-2"
                align="right"
                :data="props.row.products"
                border
                style="width: 90%; margin: auto"
              >
                <!-- <el-table-column label="#" type="index" width="50"> -->
                <!-- <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="المنتج"
                  width="300"
                  prop="name"
                ></el-table-column>
                <el-table-column label="الكمية">
                  <template slot-scope="scope">
                    {{ scope.row.pivot.qty }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="سعر البيع "
                  prop="pivot.sale_price"
                ></el-table-column>
                <el-table-column label="الاجمالي">
                  <template slot-scope="scope">
                    {{ scope.row.pivot.qty * scope.row.pivot.sale_price }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="مرتجع"
                  prop="pivot.returned_qty"
                ></el-table-column>
                <el-table-column label="الاجمالي بعد المرتجع" width="150">
                  <template slot-scope="scope">
                    {{
                      (scope.row.pivot.qty - scope.row.pivot.returned_qty) *
                      scope.row.pivot.sale_price
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showHiden"
                  label="سعر الشراء "
                  prop="pivot.buy_cost"
                ></el-table-column>
                <el-table-column label="الربح" v-if="showHiden">
                  <template slot-scope="scope">
                    {{
                      (scope.row.pivot.qty - scope.row.pivot.returned_qty) *
                      (scope.row.pivot.sale_price - scope.row.pivot.buy_cost)
                    }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <el-button
              style="width: 100%"
              v-if="tableData.length > 0 && pagination.last_page > 1"
              @click="loadMoreData"
              icon="el-icon-caret-bottom"
              >تحميل المزيد</el-button
            >
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ReportsAside from "@/components/ReportsAside.vue";
import SearchCustomers from "@/components/Customers/SearchWithoutAdd.vue";
// import { ipcRenderer } from "electron";
import CustomerInfo from "../../components/CustomerInfo.vue";

export default {
  name: "Products",

  components: {  SearchCustomers, CustomerInfo },

  data() {
    return {
      showHiden: false,
      buyCost: 0,
      totalDiscount: 0,
      filterMode: false,
      saleCost: 0,
      true: true,
      productsLength: 0,
      customer: null,
      dateRange: null,
      type: "3",
      editFormVisible: false,
      tableData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      pagination: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getSales();
  },
  methods: {
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getSales();
      }
    },
    sendToPrint(row) {
      console.log("🚀 ~ sendToPrint ~ row:", row)
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "saleInvoice",
      //   title: "مبيعات",
      //   invoiceType: "sales",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    sendToPrintAll(row) {
      console.log("🚀 ~ sendToPrintAll ~ row:", row)
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "allReports",
      //   title: " مبيعات ",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      this.filterMode = true;
      this.getSales();
    },
    selectSearchCode() {
      this.filterMode = true;
      this.getSales();
    },
    selectDateRange() {
      this.filterMode = true;
      this.getSales();
    },
    selectType() {
      this.filterMode = true;
      this.getSales();
    },
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
    deleteInvoice(invoice) {
      // alert(invoice.row.id);
      const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`sales/${invoice.row.id}`)
        .then(() => {
          this.getSales();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حذف فاتورة المبيعات بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "حدث خطأ",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
    },
    getSales() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.getSalesCost();
      if (this.filterMode) {
        this.pagination.current_page = 1;
        this.tableData = [];
      }
      let url = `inventory-sales/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?page=${this.pagination.current_page}&type=${this.type}`;
      if (this.dateRange != null) {
        url += "&start_date=" + this.dateRange[0];
        url += "&end_date=" + this.dateRange[1];
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.customer != null) {
        url += "&customer=" + this.customer.id;
      }
      this.totalDiscount = 0;
      axiosApi
        .get(url)
        .then((res) => {
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;
          this.tableData.map((invoice) => {
            this.totalDiscount += Number(invoice.discount);
            invoice.total = this.numberToFixed(invoice.total_cost);
            invoice.total_cost = this.numberToFixed(invoice.total_cost);
            invoice.discount = this.numberToFixed(invoice.discount);
            invoice["profit"] = 0;
            invoice.products.map((product) => {
              console.log(
                "profit",
                (product.pivot.qty - product.pivot.returned_qty) *
                  (product.pivot.sale_price - product.pivot.buy_cost)
              );
              invoice["profit"] +=
                (Number(product.pivot.qty) -
                  Number(product.pivot.returned_qty)) *
                (Number(product.pivot.sale_price) -
                  Number(product.pivot.buy_cost));
            });
            let pay = 0;
            if (invoice.payments.length > 0) {
              invoice.payments.map((payment) => {
                pay += Number(payment.cost);
              });
              invoice.paied_amount = pay;
            }
          });
          // for (let i = 0; i < this.tableData.length; i++) {
          //   this.tableData[i].total = 0;
          //   this.tableData[i].total_cost = 0;
          //   for (let x = 0; x < this.tableData[i].products.length; x++) {
          //     this.tableData[i].total += (this.tableData[i].products[x].pivot.sale_price * (this.tableData[i].products[x].pivot.qty - this.tableData[i].products[x].pivot.returned_qty));
          //     this.tableData[i].total_cost += this.tableData[i].products[x].pivot.sale_price * (this.tableData[i].products[x].pivot.qty - this.tableData[i].products[x].pivot.returned_qty);
          //   }
          // }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
    async getSalesCost() {
      // let loader = this.$loading.show({});
      let link = `sales-cost/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?limit=20`;

      if (this.dateRange != null) {
        link += "&start=" + this.dateRange[0];
        link += "&end=" + this.dateRange[1];
      }

      if (this.searchCode != "") {
        link += "&id=" + this.searchCode.trim();
      }
      if (this.customer != null) {
        link += "&customer_id=" + this.customer.id;
      }
      await axiosApi
        .get(link)
        .then((res) => {
          console.log("========== res.data =========", res.data);
          this.buyCost = res.data[0].buyCost;
          this.saleCost = res.data[0].saleCost;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          // loader.hide();
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
    goTo(row) {
      if (row.fatura_id != null) {
        this.$router.push("/sales/fatura-edit/" + row.id);
        console.log(row);
      } else {
        this.$router.push("/sales/edit/" + row.id);
        console.log(row);
      }
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
</style>
